module.exports = __webpack_public_path__ + "img/formulaire-creation-compte.b0e2734d.png";